import React from "react";

const LocationIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10.436" height="12.755" viewBox="0 0 10.436 12.755">
      <g transform="translate(-3 -1)">
        <path
          d="M13.436,6.218c0,4.058-5.218,7.537-5.218,7.537S3,10.276,3,6.218a5.218,5.218,0,1,1,10.436,0Z"
          fill="#0182f0"
        />
        <circle cx="2" cy="2" r="2" transform="translate(6.218 4.377)" fill="#fff" />
      </g>
    </svg>
  );
};

export default LocationIcon;
